module.exports = __webpack_public_path__ + "img/gd3.e879b496.jpg";